if ($('body.page-liste').length) {

    var listeFilters = $('#liste-filters');
    var firstMedicoRow = $('.medico-row').first();
    var rowTop = firstMedicoRow.position()?.top;
    var wrapperPosition = $('.wrapper-medici').first().position().top;
    var affixClass = 'affix';
    var colSticky = $('#col-sticky');
    var colPosition = colSticky.position().top + 10;
    var colCard = colSticky.find('> .card').first();
    var shadowClass = 'shadow-sm';

    if (colSticky.outerHeight() < window.innerHeight ) {
        colSticky.addClass('col-sticky');
    } else {
        colSticky.removeClass('col-sticky');
    }

    if (listeFilters.length) {
        $(document).scroll(function() {
            var listeFilters = $('#liste-filters');
            // questo nel caso ho aperto le mappe, i filtri spariscono!
            if (!listeFilters.length) {
                return;
            }
            var hasClass = listeFilters.hasClass(affixClass);
            var posTop = listeFilters.position().top;
            var backToOrigin = posTop <= wrapperPosition + 5;

            var colHasClass = colSticky.hasClass(affixClass);
            var colBackToOrigin = colSticky.position().top <= colPosition;

            if (!hasClass && !backToOrigin) {
                listeFilters.addClass(affixClass).addClass(shadowClass);
                hasClass = true;
                return;
            }

            if (hasClass && backToOrigin) {
                listeFilters.removeClass(affixClass).removeClass(shadowClass);
                return;
            }

            if(!colHasClass && !colBackToOrigin) {
                colSticky.addClass(affixClass)
                colHasClass = true;
                return;
            }

            if(colHasClass && colBackToOrigin) {
                colSticky.removeClass(affixClass);
            }
        });
    }
}        

$(document).ready(function() {

    var prevWindowWidth = $(window).width();

    $(this).trigger('scroll');
    if ($('body.page-liste').length) {
        
        var alreadyResizing = false;
        var firstResize = true;
        
        $(window).resize(function() {
            //check if width has changed
            if (prevWindowWidth == $(window).width() && !firstResize) {
                return;
            }

            if (alreadyResizing && !firstResize) {
                return;
            }

            alreadyResizing = true;
            var resizeTime = firstResize ? 1 : 300;

            //give sometime to resize
            setTimeout(function() {
                firstResize = false;
                //check if is desktop
                if ($(window).width() > 992) {
                    //hide the tabber and remove the tab list
                    $('.studio-wrapper').removeClass('tab-pane').removeClass('fade');
                    alreadyResizing = false;
                    return;
                }
                
                //show the tabber and add the tab list
                $('.studio-wrapper').addClass('tab-pane').addClass('fade');
                //relaunch the tabber
                $('.tab-studio').tab();
                alreadyResizing = false;
            }, resizeTime);
        });
        //trigger resize
        $(window).resize();

        /**
         * Inizializzati al first step, perchè non vengono resettati dall ajax request
         * di aggiornamento liste post filtri / ordinamenti
         */

        g4_event("Visualizzazione", {'event_category' : 'Liste', 'value' : get_current_liste_function() });

        $('.filter-box[data-filter="cambia-prestazione"] .btn-change-prest').on('click', function() {
            if($( ".list-prest-ajax" ).is(':visible')) {
                $( ".list-prest-ajax" ).slideUp();
                $('html, body').animate({scrollTop: 0}, 1000);
            } else {
                if($(".list-prest-ajax-content").html() == '') {
                    $('body').addClass('onLoading');
                    var link = $(this).data('href') + " #list-prestazioni-page";
                    $( ".list-prest-ajax-content" ).load(link, function() {
                        $('#overlayer').hide();
                        $( ".list-prest-ajax-content .nascosto" ).show();
                        $( ".list-prest-ajax" ).slideDown();

                        $('#list-prestazioni-page li a').on('click',function() {
                            g4_event("Cambiata prestazione", {'event_category' : 'Liste', 'value' : get_current_liste_function()});
                        });
                        $('body').removeClass('onLoading');
                    });
                    g4_event("Mostra altre prest attività", {'event_category' : 'Liste', 'value' : get_current_liste_function()});
                } else {
                    $( ".list-prest-ajax" ).slideDown();
                }
            }
        });

        $('.btn-close-change-prest').on('click', function() {
            $( ".list-prest-ajax" ).slideUp();
            $('html, body').animate({scrollTop: 0}, 1000);
        });

        $('.filter-col .filter-box input').on('change', function(e) {
            e.preventDefault();

            var box = $(this).closest('.filter-box');
            var typeFilter = $(box).data('filter');
            var value = $(this).val();
            setFilter(box, typeFilter, value, e);
        })

        $('.filter-box .btn[data-role="remove-filter"]').on('click', function(e) {
            e.preventDefault();
            var typeFilter = $(this).closest('.filter-box').data('filter');
            if (typeFilter) {
                removeFilter(typeFilter);
            }
        });

        $('form#lista_ajax').on('submit', function(e) {
            e.preventDefault();

            //destroy vue.js apps in .basemini-app
            $('.baseminiapp').each(function() {
                const id = $(this).attr('id');
                if(id && window[$(this).attr('id')]) {
                    window[id].$destroy();
                    window[id] = null;
                }
            });


            $('#lista_ajax #ajax_load').val("1");
            /**
             * @todo reset offcanvas menu
             */
            httpRequest(this.action, $(this).serializeArray()).then(onResult => {
                $('.medici-col').html(onResult.html);
                // if (onResult.pushUrl) {
                //     //replace the url without history
                //     window.history.replaceState({}, '', onResult.pushUrl);
                // }
                initListeJquery();
                if(!$('#map').is(':visible')) {
                    $('html, body').animate({scrollTop: 0}, 0, function() {
                        //recall vue.js after scroll time
                        setTimeout(function() {
                            window.setupBaseAppFrontend();
                        }, 750);
                    });
                }

                /* salvo i dati nella History */
                if($('#lista_ajax #save_state').val() == "1" && typeof History !== 'undefined') {
                    var formObject = {};
                    $.each($('#lista_ajax').serializeArray(), function(i, v) {
                        /**
                         * Bisogna fare attenzione a non salvare il CSRF token, altrimenti se passa un giorno
                         * va tutto in errore
                         */
                        if (v.name != '_token') {
                            formObject[v.name] = v.value;
                        }
                    });
                    hideFiltersBar();
                    History.pushState(formObject, $('#lista_ajax #page_title').val());

                    $('#lista_ajax #save_state').val('0');
                }

            }).catch(onError => {console.log(onError);
                return showError('Errore durante il caricamento della pagina, riprova fra poco');
            })
            .finally(() => {
                firstResize = true;
                $(window).trigger('resize');
            });

            return false;
        });

        $('.filter-col .map-trigger').on('click',function() {
            g4_event("Visualizza mappa desktop", {
                'event_category': 'Liste',
                'value': get_current_liste_function()
                });
            set_map_view(1);
        });

        $('.filter-col .lista-trigger').on('click',function() {
            g4_event( "Visualizza lista desktop", {'event_category' : 'Liste', 'value' : get_current_liste_function()});
            set_map_view(0);
        });

        /**
         * Questa verrà invocata a ogni ordinamento / filtraggio per rendere accessibile
         * gli elementi jquery appesi post ajax request
         */
        initListeJquery();

        if(typeof History.Adapter === 'object') {
            History.Adapter.bind(window,'statechange',function() {

                if($('#lista_ajax #ajax_load').val() == "1" && $('#lista_ajax #save_state').val() == "0") {

                    var state = History.getState();
                    var count = 0;
                    $.each(state.data, function() {
                        count++;
                    });
                    $('#lista_ajax input[name^="filters"]').val("");
                    $('#lista_ajax input[name="order"]').val("");
                    $('#lista_ajax input[name="options[page]"]').val("1");
                    $('.filter-col input[type="radio"],.filter-col input[type="checkbox"]').prop('checked',false);
                    $('.filter-box [data-role="remove-filter"]').slideUp();
                    if(count > 0) {
                        $.each(state.data, function(i, v) {
                            setFilterHistory(i, v);
                        });
                    }
                    $('#lista_ajax #save_state').val('0');
                    $('#lista_ajax').trigger("submit");
                }
            });

            History.Adapter.onDomLoad(function() {
                var state = History.getState();
                var count = 0;
                $.each(state.data, function() {
                    count++;
                });
                if(count == 0) {
                    History.replaceState({},$('#lista_ajax #page_title').val());
                } else {
                    $(document).ready(function() {
                        $.each(state.data, function(i, v) {
                            setFilterHistory(i, v);
                        });
                        $('#lista_ajax #save_state').val('0');
                        $('#lista_ajax').trigger("submit");
                    });
                }
            });

        }
    };

    window.bindStudiClick();

});

window.set_map_view = function(map) {
    $('.filter-col .mappe-btn-group').toggleClass('active');
    $('#lista_ajax input[name="mappa"]').val(map);
    $('#lista_ajax #save_state').val('1');
    $('#lista_ajax').trigger("submit");
    g4_event(map ? "Vista mappa" : "Vista lista", {'event_category' : 'Liste', 'value' : get_current_liste_function()});
    return false;
}

window.mostraFiltersBar = function() {
    $('.filter-col').addClass('show');
    $('body').addClass('overflow-hidden');
}
window.hideFiltersBar = function(e) {

    if (e && !$(e.target).hasClass('filter-col')) {
        return false;
    }

    $('body').removeClass('overflow-hidden');

    $('.filter-col').addClass('hidding');
    setTimeout(function() {
        $('.filter-col').removeClass('hidding');
        $('.filter-col').removeClass('show');
    }, 500);
}

window.setFilterHistory = function(i, v) {
    if (!$('#lista_ajax input[name="' + i + '"]').length) {
        $('#lista_ajax').append($('<input type="hidden" name="' + i + '" />'));
    }
    $('#lista_ajax input[name="'+i+'"]').val(v);

    if(i == "filters[tipo_studio]" && v) {

        $('.filter-box[data-filter="tipo_studio"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="tipo_studio"] [data-role="remove-filter"]').slideDown();

        $('.filter-box[data-filter="distanza"] input').attr('disabled', 'disabled');
        $('.filter-box[data-filter="distanza"] [data-role="remove-filter"]').slideUp();
    }
    if(i == "filters[onlyPromo]") {
        $('.filter-box[data-filter="onlyPromo"] input[type="checkbox"]').prop('checked',true);
    }
    if(i == "filters[distanza]" && v) {
        $('.filter-box[data-filter="tipo_studio"] input').attr('disabled', 'disabled');
        $('.filter-box[data-filter="tipo_studio"] .material-switch').addClass('disabled');

        $('.filter-box[data-filter="distanza"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="distanza"] [data-role="remove-filter"]').slideDown();
    }
    if(i == "filters[patologia]" && v) {
        $('.filter-box[data-filter="patologia"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="patologia"] [data-role="remove-filter"]').slideDown();
    }
    if(i == "filters[specializzazione]" && v) {
        $('.filter-box[data-filter="specializzazione"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="specializzazione"] [data-role="remove-filter"]').slideDown();
    }
    if(i == "filters[provincia_videoconsulto]" && v) {
        $('.filter-box[data-filter="provincia_videoconsulto"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="provincia_videoconsulto"] [data-role="remove-filter"]').slideDown();
    }
    if(i == "filters[provinciaStudio]" && v) {
        $('.filter-box[data-filter="provinciaStudio"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="provinciaStudio"] [data-role="remove-filter"]').slideDown();
    }
    if(i == "filters[prestazioneMedico]" && v) {
        $('.filter-box[data-filter="prestazioneMedico"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="prestazioneMedico"] [data-role="remove-filter"]').slideDown();
    }
    if(i == "mappa" && v == "1") {
        $('.filter-col .mappe-btn-group').toggleClass('active');
    }
    if(i == "filters[urgente]" && v) {
        $('.filter-box[data-filter="urgente"] input[value="'+v+'"]').prop('checked',true);
        $('.filter-box[data-filter="urgente"] [data-role="remove-filter"]').slideDown();
    }
}
window.setFilter = async function(box, filterType, value, event) {

    if ($(event.target).attr('type') == 'checkbox' && !$(event.target).is(':checked')) {
        return removeFilter(filterType);
    }

    if (box.find('.btn[data-role="remove-filter"]').length) {
        box.find('.btn[data-role="remove-filter"]').slideDown();
    }

    var labelGaEvent = 'Filtro '+ filterType;
    switch (filterType) {
        case 'tipo_studio':
            labelGaEvent = 'Filtro domicilio';
            $('.filter-box[data-filter="distanza"] input').attr('disabled', 'disabled');
            break;
        case 'onlyPromo':
            labelGaEvent = 'Filtro promozioni';
            break;
        case 'videoconsulti':
            labelGaEvent = 'Filtro videoconsulti';
            break;
        case 'distanza':
            if(!$('#lista_ajax #latitudine').val() || !$('#lista_ajax #longitudine').val()) {
                try {
                    let coord = await window.requestLocation();
                    $('#lista_ajax #latitudine').val(coord.coords.latitude);
                    $('#lista_ajax #longitudine').val(coord.coords.longitude);
                } catch (error) {
                    return showError(error);
                }
            }
            labelGaEvent = 'Filtro distanza';
            $('.filter-box[data-filter="tipo_studio"] input').attr('disabled', 'disabled');
            $('.filter-box[data-filter="tipo_studio"] .material-switch').addClass('disabled');
            break;
        case 'patologia':
            labelGaEvent = 'Filtro keyword';
            break;
        case 'specializzazione':
            labelGaEvent = 'Filtro Specializzazione';
            break;
        case 'urgente':
            labelGaEvent = 'Filtro urgenza';
            break;
    }
    if (!$('#lista_ajax input[name="filters['+filterType+']"]').length) {
        $('#lista_ajax').append($('<input type="hidden" name="filters['+filterType+']"  />'));
    }
    $('#lista_ajax input[name="filters['+filterType+']"]').val(value);
    $('#lista_ajax input[name="options[page]"]').val(1);
    $('#lista_ajax #save_state').val('1');
    $('#lista_ajax').trigger('submit');
    g4_event(labelGaEvent, {'event_category' : 'Liste', 'value' : get_current_liste_function()});
}

window.removeFilter = function(filter) {
    if ($('.filter-box[data-filter="' + filter + '"] .btn[data-role="remove-filter"]').length) {
        $('.filter-box[data-filter="' + filter + '"] .btn[data-role="remove-filter"]').slideUp();
    }
    $('.filter-box[data-filter="' + filter + '"] input').prop('checked', false);
    switch (filter) {
        case 'tipo_studio':
            $('.filter-box[data-filter="distanza"] input').removeAttr('disabled');
            break;
        case 'distanza':
            $('#lista_ajax #latitudine').val('');
            $('#lista_ajax #longitudine').val('');
            $('.filter-box[data-filter="tipo_studio"] input').removeAttr('disabled');
            $('.filter-box[data-filter="tipo_studio"] .material-switch').removeClass('disabled');
            break;
    }
    if ($('#lista_ajax input[name="filters['+filter+']"]').length) {
        $('#lista_ajax input[name="filters['+filter+']"]').remove();
    }
    $('#lista_ajax input[name="options[page]"]').val(1);
    $('#lista_ajax #save_state').val('1');
    $('#lista_ajax').trigger("submit");
    return false;
}

window.loadComments = function(id, media, target) {
    if (!id) return;
    if (!window.appListe || !window.appListe.$refs.medicoReviews) {
        return;
    }
    return window.appListe.$refs.medicoReviews.show(id, media, target);
};

window.initListeJquery = function() {
    
    $('.medico-row a[data-target="Clinica"]').on('click', function(e) {
        const idSpec = $(this).data('specializzazione');
        if (idSpec) {
            e.preventDefault();
            const newUrl = $(this).attr('href') + '?specializzazione=' + idSpec;
            window.location.href = newUrl;
        }

    });
    if ($('body.page-liste').length) {

        $('.popup-opinioni-pazienti-medico:not("no-opinioni")').on('click', function(e) {
            loadComments($(this).data('id'), $(this).data('media'), $(this).data('target'));
        });

        $('[data-pagination-ajax="1"]').on('click', function(e) {
            e.preventDefault();
            $('#lista_ajax input[name="options[page]"]').val($(this).data('page'));
            $('#lista_ajax #save_state').val('1');
            $('#lista_ajax').trigger("submit");
        });

        setupTooltips();

        $('.page-liste [data-role="order"]').on('click', function(e) {
            e.preventDefault();
            if($(this).attr('disabled') == "disabled" || $(this).hasClass('active')) {

                return false;
            }
            set_attivita_order($(this).data('order'));
        });

        $('.btn-mostra-scondi').on('click', function(e) {
            e.preventDefault();
            let idMedico = $(this).data('id-medico');
            if (!idMedico) return;
            var btn = $(this);
            $('#medico_row_' + idMedico).find('.elenco-studi .studio-wrapper.nascosto').slideToggle(400, function() {

            });

            setTimeout(function() {
                btn.attr('data-expanded' , btn.attr('data-expanded') == 'true' ? 'false' : 'true');
            }, 401);
        });

        $('a[data-role="medico"]').on('click', function(e) {
            g4_event("Click nome medico", {'event_category' : 'Liste', 'value': get_current_liste_function() });
        });

        $('a.foto-medico').on('click', function(e) {
            g4_event("Click foto medico", {'event_category' : 'Liste', 'value': get_current_liste_function() });
        });

        // $('.reload-studio-data').on('click', function(e) {
        //     console.log('reload-studio-data');
        //     e.preventDefault();
        //     var idStudio = $(this).data('id-studio');
        //     console.log('idStudio', idStudio);
        //     if (!idStudio) return;
        //     var row = $('.studio-wrapper[data-id="'+idStudio+'"]').first();

        //     if(!row) return;

        //     row.removeClass('active');
        //     console.log('row', row);
        //     row.trigger('click');
        // });

        $('.elenco-studi li.studio-wrapper').not('.no-disp').on('click',function(e) {
            //if (e.target.nodeName == 'A') return;

            e.preventDefault();
            g4_event("Click row studio", {'event_category' : 'Liste', 'value': get_current_liste_function() });

            const row = $(this).closest('.medico-row');
            const id_medico = $(row).attr('id').replace('medico_row_','');
            const nome_medico = $(row).find('[data-role="medico"]').text();
// const listEventData = window.idocAnalyticsEvents?.data;
            // const listItemDetail = listEventData?.items.find(item => item.item_id == id_medico);

            // const listItemClick = {
            //     content_type: listItemDetail?.item_type,
            //     items: [{
            //         item_id: id_medico,
            //         item_name: nome_medico,
            //     }],
            // };
            // g4_event('select_item', listItemClick);

            if(row.hasClass('.sponsored')) {
                g4_event("Click medico", {'event_category' : 'Sponsored', 'value' : id_medico + ": " + nome_medico });
                setCookie('clk_sponsored', id_medico, 1, '/', 'o');
            }

            var form = $($(this).find('form'));
            //check if form is visible

            if (form && form.is(':visible')) {
                form.attr('target', '');
                if (e.shiftKey || e.ctrlKey || e.metaKey) {
                    form.attr('target', '');
                }
                form.submit();
            }
        });

        //@todo credo si possa rimuovere
        $('.elenco-studi li.studio-wrapper form').on('submit',function(e) {
            g4_event("Click pulsante prenota", {'event_category': 'Liste', 'value' : get_current_liste_function()});
        });

        $('.wrapper-medici .lista-trigger').on('click',function() {
            g4_event("Visualizza lista link", {'event_category' : 'Liste', 'value' : get_current_liste_function() });
            set_map_view(0);
        });

        $('.wrapper-medici .medico-row.sponsored').each(function(k,v) {
            var id_medico = $(v).attr('id').replace('medico_row_','');
            var nome_medico = $(row).find('[data-role="medico"]').text();
            g4_event("Visualizzato medico", {'event_category': 'Liste', 'value' : id_medico + ": " + nome_medico});
        })
    }
}

window.get_current_liste_function = function() {
    var curr_fn = $('#lista_ajax input[name="options[function]"]').val();
    if(curr_fn == 'nearby') {
        if($('#lista_ajax input[name="options[id_keyword]"]').val()) {
            curr_fn += "_keyword";
        } else if($('#lista_ajax input[name="options[id_prestazione]"]').val()) {
            curr_fn += "_prestazione";
        } else if($('#lista_ajax input[name="options[id_specializzazione]"]').val()) {
            curr_fn += "_specializzazione";
        }
        if($('#lista_ajax input[name="options[id_citta]"]').val()) {
            curr_fn += "_citta";
        }
    }
    return curr_fn;
}

window.set_attivita_order = async function(order) {
    if(order == 'distanza') {
        if(!$('#lista_ajax #latitudine').val() || !$('#lista_ajax #longitudine').val()) {
            try {
                let coord = await window.requestLocation();
                $('#lista_ajax #latitudine').val(coord.coords.latitude);
                $('#lista_ajax #longitudine').val(coord.coords.longitude);
            } catch (error) {
                return showError(error);
            }

            return set_attivita_order(order);
        }
    }
    $('#lista_ajax input[name="order"]').val(order);
    $('#lista_ajax input[name="options[page]"]').val(1);
    $('#lista_ajax #save_state').val('1');
    $('#lista_ajax').trigger("submit");
    if(order) {
        g4_event("Ordinamento " + order,{'event_category': 'Liste', 'value' : get_current_liste_function()});
    }
    return false;
}

window.setupBaseAppFrontend = function() {
    window.initBaseAppFrontend();
    window.bindStudiClick();
}

window.countLines = function (el) {
    var divHeight = $(el).height();
    var lineHeight = parseInt($(el).css('line-height'), 10);
    var lines = divHeight / lineHeight;

    if(lines > 2) {
        //insert text after 67 chars
        var presso = $(el).find('.presso2');
        var text = presso.text();
        var newText = text.substring(0, 55);
        presso.text(newText);

        $(el).append(' <a href="#" class="readmore" data-expanded="false">...altro</a>');
        $(el).find('.readmore').on('click', function(e) {
            e.preventDefault();
            var expanded = $(this).attr('data-expanded') == 'true';

            $(this).attr('data-expanded', !expanded);
            $(this).text(expanded ? '...altro' : '...meno');
            presso.text(expanded ? newText : text);
        });
    }

}


window.bindStudiClick = function() {
    $('.studio.domicilio').each(function() {
        window.countLines($(this));
    });
    $('.studio-wrapper, .tab-studio').on('click', function(e) {

        const target = $(e.target);

        //check if target has data-toggle
        if (target.data('toggle') == 'collapse') {
            return;
        }
        
        //do not prevent default if is a tab
        if($(this).attr('role') != 'tab') {    
            e.preventDefault();
            e.stopPropagation();
        }

        const isButton = target.prop('nodeName').toLowerCase() == 'button';
        const isBtnPrenota = target.hasClass('prenota-btn') && isButton;
        
        if (isBtnPrenota) {
            const form = target.closest('form');
            g4_event("Click pulsante prenota", {'event_category': 'Liste', 'value' : get_current_liste_function()});
            return form.submit();
        }

        //get the parent and remove class active to all studio-wrapper elements and assign it to current
        var parent = $(this).parent();

        if ($(this).hasClass('active')) {
            return;
        }
        
        let studioId = $(this).data('studio-id');

        if($(this).attr('role') != 'tab') {
            parent.find('.studio-wrapper').removeClass('active');
            $(this).addClass('active');
            studioId = $(this).data('id');
        }
        
        const wrapper = $(this).data('wrapper-id');
        const idPrestazione = $(this).data('id-prestazione');
        const $app = $('#' + wrapper + ' .baseminiapp').first();
        const ref = window[$app.attr('id')]?.$refs;

        ref?.disponibilitaliste.updateDisponibilita({studioId : studioId, idPrestazione: idPrestazione}, true);

    });
}
